import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [status, setStatus] = useState({ type: null, message: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus({ type: null, message: '' });

        try {
            const params = new URLSearchParams(formData).toString();
            const response = await fetch(`https://cmsapi.mks.org.au/api/contact?${params}`, {
                method: 'POST',
                headers: {
                    'accept': '*/*'
                }
            });

            if (response.ok) {
                setShowSuccessPopup(true);
                setFormData({ name: '', email: '', phone: '', message: '' });
                // Still clear status if needed, but the popup is the main feedback now
            } else {
                throw new Error('Failed to send message');
            }
        } catch (error) {
            console.error("Contact form error:", error);
            setStatus({ type: 'error', message: 'Something went wrong. Please try again later.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-page">
            {/* Hero Section */}
            <section className="contact-hero">
                <div className="contact-hero-overlay"></div>
                {/* The hero image background will be styled in CSS. User provided an image, 
            but usually we just use a generic class. I'll use inline style or css class */}
                <div className="contact-hero-bg"></div>
                <div className="contact-hero-content">
                    <h1 className="contact-hero-title">Contact Us</h1>
                </div>
            </section>

            {/* Main Content Sections with defined gradient background */}
            <div className="contact-main-wrapper">
                <div className="contact-container">

                    <div className="contact-grid">
                        {/* Section 1: Contact Information */}
                        <div className="contact-info-section">
                            <h2 className="contact-section-title">Get In Touch</h2>
                            <div className="contact-section-line"></div>

                            <div className="contact-details-box">
                                <div className="contact-detail-item">
                                    <div className="contact-icon">📍</div>
                                    <div className="contact-text">
                                        <h3>Address</h3>
                                        <p>Melbourne Kannada Sangha</p>
                                        <p>1173 Heatherton Rd, Noble Park, VIC 3174, Australia</p>
                                    </div>
                                </div>

                                <div className="contact-detail-item">
                                    <div className="contact-icon">📱</div>
                                    <div className="contact-text">
                                        <h3>Phone</h3>
                                        <p>WhatsApp: 0452 036</p>
                                        <p>Srinivas Sharma — +61 401 900 080</p>
                                    </div>
                                </div>

                                <div className="contact-detail-item">
                                    <div className="contact-icon">✉️</div>
                                    <div className="contact-text">
                                        <h3>Email</h3>
                                        <p><a href="mailto:melnudi@gmail.com">melnudi@gmail.com</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 2: Contact Form */}
                        <div className="contact-form-section">
                            <h2 className="contact-section-title">Send a Message</h2>
                            <div className="contact-section-line"></div>

                            <div className="contact-form-card">
                                {status.message && (
                                    <div className={`contact-status-message ${status.type}`}>
                                        {status.message}
                                    </div>
                                )}
                                <form className="contact-form" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="name">Name</label>
                                        <input 
                                            type="text" 
                                            id="name" 
                                            placeholder="Your Name" 
                                            value={formData.name}
                                            onChange={handleChange}
                                            required 
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="email">Email</label>
                                        <input 
                                            type="email" 
                                            id="email" 
                                            placeholder="Your Email Address" 
                                            value={formData.email}
                                            onChange={handleChange}
                                            required 
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="phone">Phone</label>
                                        <input 
                                            type="tel" 
                                            id="phone" 
                                            placeholder="Your Phone Number" 
                                            value={formData.phone}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="message">Message</label>
                                        <textarea 
                                            id="message" 
                                            rows="5" 
                                            placeholder="How can we help you?" 
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>

                                    <button 
                                        type="submit" 
                                        className="contact-submit-btn" 
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Sending...' : 'Send Message'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* Success Popup Modal */}
            {showSuccessPopup && (
                <div className="contact-popup-overlay" onClick={() => setShowSuccessPopup(false)}>
                    <div className="contact-popup-card" onClick={(e) => e.stopPropagation()}>
                        <div className="contact-popup-close" onClick={() => setShowSuccessPopup(false)}>×</div>
                        <div className="contact-popup-icon">✅</div>
                        <h2 className="contact-popup-title">Message Sent!</h2>
                        <p className="contact-popup-text">
                            Thank you for reaching out! Your message has been sent successfully. 
                            Our team will get back to you as soon as possible.
                        </p>
                        <button 
                            className="contact-popup-btn" 
                            onClick={() => setShowSuccessPopup(false)}
                        >
                            Got it, thanks!
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Contact;